import React from "react";
import { inject, observer } from "mobx-react";
import { computed, observable } from "mobx";

import { Grid } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import AddApplicationLink from "./AddApplicationLink/AddApplicationLink";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import TableSearchInput from "@src/Components/Common/TableSearchInput/TableSearchInput";
import ApplicationLinkTable from "./ApplicationLinkTable/ApplicationLinkTable";
import { Values } from "@src/Tools/Values";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { ApplicationLink } from "@src/Interfaces/Entity/ApplicationLink";
import _ from "lodash";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("auth", "management")
@observer
class ApplicationsContent extends React.Component<IProps> {
  @observable searchText: string = "";

  @computed get filteredApplicationLinks() {
    return filterByTableColumns<ApplicationLink>(
      _.unionBy(this.props.management.baseApplicationLinks, this.props.management.applicationLinks.filter(app => !app.baseApplication), 'id'),
      this.searchText
    );
  }

  handleChange = (event: any) => {
    this.searchText = event.target.value;
  };

  render() {
    return (
      <Grid container direction="column">
        <STPageHeader>{Values.getLocalizationValue("applications")}</STPageHeader>
        <Grid container justify="space-between" alignItems="center" item>
          <Grid item>
            <TableSearchInput
              value={this.searchText}
              onChange={this.handleChange}
            />
          </Grid>
          {this.props.auth.user.location.primary && (
            <AddApplicationLink />
          )}
        </Grid>
        <Grid item xs>
          {this.filteredApplicationLinks.length > 0 ? (
            <ApplicationLinkTable applications={this.filteredApplicationLinks} />
          ) : (
            <ResultsAreEmpty />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default ApplicationsContent;
